import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import SolutionMarketplaceFeatures from "./SolutionMarketplaceFeatures";
import SolutionMarketplacebenefits from "./SolutionMarketplacebenefits";
import "./SolutionMarketplace.css";

// Main component for ServerSolution

export default function ServerSolution() {
  // Overview Data containing different server solutions
  const data1 = [
    // EdgeStack processes data locally, reducing latency and bandwidth usage.
    "Core Stack: Core Stack is a digital backbone that integrates AI/ML, blockchain, and IoT to power smart, connected agribusiness solutions. It streamlines operations, enhances traceability, and supports data-driven decision-making across the agricultural value chain. ",
    "AgriCloud Stack: AgriCloud Stack is a cloud-based platform that centralizes data, tools, and services for modern agriculture. It enables real-time data access, scalable storage, and seamless integration of AI, IoT, and analytics to support precision farming, supply chain management, and informed decision-making."
  
  ];

  const data2 = [
"    SDH: The Core Edge Stack centrally processes and orchestrates data by integrating edge devices and services across the GBR ecosystem, bridging cloud and local nodes. Alongside, the Edge AI Stack delivers AI-powered insights directly at the data source, enabling agribusinesses to make faster, smarter decisions with minimal latency."
  ]

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="solution-marketplace-bg"
        bannerTitle={["ServerSolutions"]}
        bannerbodycopy="edgeStack | AgriCloud"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="SolutionMarketplace" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features & Benefits Section */}
      <SolutionMarketplaceFeatures />
      <SolutionMarketplacebenefits />
    </>
  );
}

